import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

function createTableHead(config?: Record<string, any>): HTMLTableSectionElement {
    return exElement.create({
        merge: config,
        tag: 'thead',
    }) as HTMLTableSectionElement;
}

// ----------------------------------------------------------------------------

export default createTableHead;
